<template>
  <b-modal
    ref="attachmentFilename"
    :title="$t('viewer.modalAttachmentFilename.title')"
    centered
    modal-class="update-name-modal"
    static
    size="xs"
    @shown="focusInput"
  >
    <b-row class="p-4">
      <b-col>
        <div class="form-label">
          <label>{{ $t('viewer.modalAttachmentFilename.filenameLabel') }}</label>
        </div>
        <vt-input
          v-if="!createCopy"
          ref="filenameInput"
          v-model="attachmentFilename"
          class="form-control-sm"
          disabled
        />
        <vt-input
          v-if="createCopy"
          ref="filenameInput"
          v-model="modifiedFilename"
          class="form-control-sm"
        />

        <div
          v-if="annotationId"
          class="form-label"
        >
          <label>{{ $t('viewer.modalAttachmentFilename.createCopy') }}</label>
        </div>
        <div
          v-if="annotationId"
          class="col-3 switch-btn p-0"
        >
          <input
            id="copy_toggle"
            v-model="createCopy"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="copy_toggle"
            class="switch"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-7 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            @click="ok()"
          >
            <span class="fal fa-save mr-2" />
            {{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
    name: 'ModalAttachmentFilename',
    data() {
        return {
            attachmentFilename: null,
            modifiedFilename: null,
            createCopy: false,
            annotationId: ''
        }
    },
    methods: {
        show(attachmentFilename, annotationId) {
            this.attachmentFilename = attachmentFilename
            this.modifiedFilename = attachmentFilename
            this.annotationId = annotationId
            this.createCopy = !annotationId
            this.modifiedFilename += this.$t('viewer.modalAttachmentFilename.filenameCopySuffix')
            this.$refs.attachmentFilename.show()
        },
        focusInput() {
            this.$nextTick(() => {
                this.$refs.filenameInput.focus()
            })
        },
        ok() {
            this.$emit('ok', (this.createCopy ? this.modifiedFilename : this.attachmentFilename))
            this.hide()
        },
        hide() {
            this.$refs.attachmentFilename.hide()
        }
    }
}

</script>
